import React from 'react';

const About = () => {
  return (
    <div className="page-content">
      <div className="page-header">
        <h1>About Dead Air</h1>
      </div>
      <div className="page-text">
        <p>
          At DeadAir.ai, we operate at the intersection of advanced artificial intelligence, behavioral science, and secure distributed systems. Our platform leverages proprietary agent-based architectures and adaptive language models to deliver levels of influence and engagement that few organizations can match. By combining elite technical expertise with a singular focus on measurable impact, we've built technology that is as precise as it is resilient-capable of shaping conversations across digital landscapes while maintaining the highest standards of reliability and control.
        </p>
        <p>
          We are more than a technology company—we are a safeguard against the rising tide of polarization and digital toxicity. Our solutions are designed for leaders and institutions who recognize that the future of discourse depends on scalable, intelligent intervention. With an unwavering commitment to innovation, anonymity, and mission integrity, DeadAir.ai provides a capability that remains out of reach for most: the power to strategically engage at scale without compromise.
        </p>
      </div>
    </div>
  );
};

export default About;